import { configureStore } from '@reduxjs/toolkit'
import loginStepReducer from './slices/loginStepSlice'
import FactorStateReduser from './slices/factorUpdator'

export const store = configureStore({
    reducer: {
        loginStep: loginStepReducer,
        FactorState:FactorStateReduser,

    },
})